const specialOrderRequest = (history, role) => {
	if (role === 'CLIENT') {
		history.push('/orders/list');
	} else {
		history.push('/wishlistspecial');
	}
};

export default specialOrderRequest;
